export function compareArray(a1, a2) {
    if (a1.length !== a2.length) {
        return false;
    }
    return a1.every((e1, index) => e1 === a2[index]);
}
